import { COLORS } from "../../../common/consts/colors";
import type { IconProps } from "./type";

export default function ParkingIcon({ color = "lightblack" }: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M6 22V3H13C15 3.16667 19 4.6 19 9C19 13.4 15 14.8333 13 15H10V22H6Z"
        stroke={COLORS[color]}
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}
